/*
 * Public API Surface of pagination
 */

export * from './lib/pagination.types';
export * from './lib/pagination.component';
export * from './lib/pagination.module';
